/**
 * Эффективный набор районов на витрине: чем домен разрешил работать.
 *
 * Считает его СЕРВЕР (`brand.regions ∩ org.allowed_regions`, ответ `/species`).
 * Здесь только чтение — и это принципиально: переключатель района, посчитанный
 * в браузере, был бы удобством, а не защитой, и чужой бассейн уезжал бы первому
 * же запросу мимо интерфейса.
 *
 * Пустое пересечение сервер отдаёт КОДОМ (`403 region_forbidden`), а не пустым
 * списком: пустой экран неотличим от аварии бэкенда.
 */

import { ApiError } from '../api'
import { parseErrorDetail } from '../i18n/apiLabels'

/** Отказ домена в районах — тот, под который рисуется плашка. */
export function isRegionForbidden(error: unknown): boolean {
  if (!(error instanceof ApiError) || error.status !== 403) return false
  return parseErrorDetail(error.detail)?.code === 'region_forbidden'
}
